import React, { useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment/moment";
import {
    grouplist,
    groupmemberlist,
    memberdetail,
    preloancreate,
    preloandelete,
} from "../../../services/admin";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export default function PreLoancollection() {
    const [glist, setGlist] = useState([]);
    const [mgrpid, setMGrpId] = useState("");
    const [grpid, setGrpId] = useState("");
    const [mlist, setMlist] = useState([]);
    const [memid, setMemId] = useState("");
    const [llist, setLlist] = useState([]);
    const [loanid, setLoanId] = useState("");

    const [filterProduct, setFilterProduct] = useState([]);
    const [originalProduct, setOriginalProduct] = useState([]);

    useEffect(() => {
        const temp = new FormData();
        temp.append("branch", localStorage.getItem("branch"));
        grouplist(temp).then((res) => {
            if (res.status === true) {
                const arr = res.data.map((item) => ({
                    value: item.id,
                    label: item.group_name,
                }));
                setGlist(arr);
            }
        });
    }, []);

    function handlegroup(e) {
        if (e) {
            setMGrpId(e);
            setGrpId(e.value);
            setMemId("");
            setMlist([]);
            setFilterProduct([]);
            groupmemberlist(e.value).then((res) => {
                if (res.status === true) {
                    setMlist(res.data);
                }
            });
        } else {
            setMGrpId("");
            setGrpId("");
            setMemId("");
            setMlist([]);
            setFilterProduct([]);
        }
    }
function formatDate(dateStr) {
    if (!dateStr) return "";
    const parsedDate = moment(dateStr, ["DD.MM.YYYY", "YYYY-MM-DD"]);
    return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
}
    function handlemember(e) {
        const memberId = e.target.value;
        setMemId(memberId);
        setFilterProduct([]);
        if (memberId !== "") {
            memberdetail(memberId).then((res) => {
                if (res.status === true) {
                    const sdata = res.data.loan_details
                        .filter((item) => item.loan_status == 1)
                        .map((loan) => {
                            return {
                                ...loan,
                                entries: loan.entries.map((entry) => {
                                    return {
                                        ...entry,
                                        loan_duedate: formatDate(entry.loan_duedate),
                                        loan_paiddate: formatDate(entry.loan_paiddate)
                                    };
                                }),
                            };
                        });
                    setLlist(sdata);
                }
            });
        }
    }

    function listmem(mid, lid) {
        setFilterProduct([]);
        setOriginalProduct([]);
        setLlist([]);
        if (mid !== "") {
            memberdetail(mid).then((res) => {
                if (res.status === true) {
                    const sdata = res.data.loan_details
                        .filter((item) => item.loan_status == 1)
                        .map((loan) => {
                            return {
                                ...loan,
                                entries: loan.entries.map((entry) => {
                                    return {
                                        ...entry,
                                        loan_duedate: formatDate(entry.loan_duedate),
                                        loan_paiddate: formatDate(entry.loan_paiddate)
                                    };
                                }),
                            };
                        });
                    setLlist(sdata);

                    if (lid !== "") {
                        const selected = sdata.filter((item) => item.loan_entry_id == lid);
                        setFilterProduct(JSON.parse(JSON.stringify(selected))); // editable
                        setOriginalProduct(JSON.parse(JSON.stringify(selected))); // original copy
                    }
                }
            });
        }


    }

    function handleloan(e) {
        setFilterProduct([]);

        const loanId = e.target.value;
        setLoanId(loanId);
        if (loanId !== "") {
            const selected = llist.filter((item) => item.loan_entry_id == loanId);
            setFilterProduct(JSON.parse(JSON.stringify(selected))); // editable
            setOriginalProduct(JSON.parse(JSON.stringify(selected))); // original copy
        }
    }

    function handleInputChange(itemIndex, entryIndex, field, value) {
        const updated = [...filterProduct];
        updated[itemIndex].entries[entryIndex][field] = value;
        setFilterProduct(updated);
    }

    function handleSave(entry, entryIndex, itemIndex) {
        const originalEntry = originalProduct[itemIndex].entries[entryIndex];
        const changes = {};

        if (entry.loan_paiddate !== originalEntry.loan_paiddate) {
            changes.loan_paiddate = entry.loan_paiddate;
        }
        if (entry.loan_interest !== originalEntry.loan_interest) {
            changes.loan_interest = entry.loan_interest;
        }

        const temp = new FormData();
        temp.append("loan_id", entry.loan_id);
        temp.append("no_of_dues", llist[0].no_of_dues);
        temp.append("loan_paiddate", entry.loan_paiddate )
        // moment(entry.loan_paiddate, "DD.MM.YYYY").format("YYYY-MM-DD"));
        temp.append("loan_interest", entry.loan_interest);
        temp.append("loan_principle", entry.loan_principle);
        preloancreate(temp).then((res) => {
            if (res.status === true) {
                listmem(memid, loanid);
                toast.success(res.message);
            }
        })

        // if (Object.keys(changes).length > 0) {
        //     changes.id = entry.id;
        //     console.log("Changed fields to save:", entry);
        // } else {
        //     console.log("No changes detected.");
        // }
    }

    function handleDelete(entry) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            preloandelete(entry.loan_id, entry.loan_entry_id).then((res) => {
                if (res.status === true) {
                    listmem(memid, loanid);
                    toast.success(res.message);
                }
            })
        })

    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                    Pre Loan Posting
                </h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Pre Loan Collection</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Pre Loan Posting
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    Pre Loan Posting
                                </h2>
                            </div>
                            <div className="card-body">
                                {/* Filters */}
                                <div className="row">
                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Group<span className="text-danger"> *</span>
                                            </label>
                                            <Select
                                                className="default-select"
                                                placeholder="Select Group"
                                                value={mgrpid}
                                                options={glist}
                                                onChange={handlegroup}
                                                isSearchable
                                                isClearable
                                            />
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Member<span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="form-control"
                                                onChange={handlemember}
                                                value={memid}
                                            >
                                                <option value="">Select Member</option>
                                                {mlist.map((item, index) => (
                                                    <option key={index} value={item.id}>
                                                        {item.member_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-sm-6">
                                        <div className="mb-6">
                                            <label className="form-label">
                                                Loan Scheme<span className="text-danger"> *</span>
                                            </label>
                                            <select
                                                className="form-control"
                                                onChange={handleloan}
                                                value={loanid}
                                            >
                                                <option value="">Select Loan Scheme</option>
                                                {llist.map((item, index) => (
                                                    <option key={index} value={item.loan_entry_id}>
                                                        {item.scheme_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* Loan Table */}
                                {filterProduct.map((item, itemIndex) => (
                                    <div className="row mt-4" key={itemIndex}>
                                        <div className="table-container">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Due Date</th>
                                                        <th>Paid Date</th>
                                                        <th>Principle</th>
                                                        <th>Interest</th>
                                                        <th>Total</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item.entries.map((entry, entryIndex) => {
                                                        const isPending = !entry.loanpaid || entry.loanpaid === "0";

                                                        const firstUnpaidIndex = item.entries.findIndex(
                                                            (e) => !e.loanpaid || e.loanpaid === "0"
                                                        );

                                                        const isEditable = entryIndex === firstUnpaidIndex;
                                                        return (
                                                            <tr key={entryIndex}>
                                                                <td>{entryIndex + 1}</td>
                                                                <td> {moment(entry.loan_duedate).format("DD-MM-YYYY")}</td>

                                                                <td>
                                                                    {isPending && isEditable ? (
                                                                        <input
                                                                            type="date"
                                                                            value={entry.loan_paiddate}
                                                                            // value={
                                                                            //     moment(entry.loan_paiddate, "DD.MM.YYYY").format("YYYY-MM-DD") || ""
                                                                            // }
                                                                            onChange={(e) =>
                                                                                handleInputChange(
                                                                                    itemIndex,
                                                                                    entryIndex,
                                                                                    "loan_paiddate",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        moment(entry.loan_paiddate).format("DD-MM-YYYY")
                                                                    )}
                                                                </td>

                                                                <td>{entry.loan_principle}</td>

                                                                <td>
                                                                    {isPending && isEditable ? (
                                                                        <input
                                                                            type="number"
                                                                            value={entry.loan_interest || ""}
                                                                            onChange={(e) =>
                                                                                handleInputChange(
                                                                                    itemIndex,
                                                                                    entryIndex,
                                                                                    "loan_interest",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                        />
                                                                    ) : (
                                                                        entry.loan_interest
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    {parseFloat(entry.loan_principle || 0) + parseFloat(entry.loan_interest || 0)}
                                                                </td>

                                                                <td>
                                                                    {entry.payment_type === "advanced" ? (
                                                                        <>
                                                                            <span className="text-success font-weight-bold me-2">Paid</span>
                                                                            <button
                                                                                className="btn btn-sm btn-danger"
                                                                                onClick={() => handleDelete(entry)}
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        </>
                                                                    ) : isPending && isEditable ? (
                                                                        <>
                                                                            <button
                                                                                className="btn btn-sm btn-success me-2"
                                                                                onClick={() => handleSave(entry, entryIndex, itemIndex)}
                                                                            >
                                                                                Save
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-sm btn-danger"
                                                                                onClick={() => handleDelete(entry)}
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        </>
                                                                    ) : isPending ? (
                                                                        <span className="text-muted">Pending</span>
                                                                    ) : (
                                                                        <span className="text-success font-weight-bold">Paid</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );

                                                        // return (
                                                        //     <tr key={entryIndex} >
                                                        //         <td>{entryIndex + 1}</td>
                                                        //         <td>{entry.loan_duedate}</td>

                                                        //         <td>
                                                        //             {isPending ? (
                                                        //                 <input
                                                        //                     type="date"
                                                        //                     value={moment(entry.loan_paiddate, "DD.MM.YYYY").format("YYYY-MM-DD") || ""}
                                                        //                     onChange={(e) =>
                                                        //                         handleInputChange(
                                                        //                             itemIndex,
                                                        //                             entryIndex,
                                                        //                             "loan_paiddate",
                                                        //                             e.target.value
                                                        //                         )
                                                        //                     }
                                                        //                 />
                                                        //             ) : (
                                                        //                 entry.loan_paiddate
                                                        //             )}
                                                        //         </td>

                                                        //         <td>{entry.loan_principle}</td>

                                                        //         <td>
                                                        //             {isPending ? (
                                                        //                 <input
                                                        //                     type="number"
                                                        //                     value={entry.loan_interest || ""}
                                                        //                     onChange={(e) =>
                                                        //                         handleInputChange(
                                                        //                             itemIndex,
                                                        //                             entryIndex,
                                                        //                             "loan_interest",
                                                        //                             e.target.value
                                                        //                         )
                                                        //                     }
                                                        //                 />
                                                        //             ) : (
                                                        //                 entry.loan_interest
                                                        //             )}
                                                        //         </td>

                                                        //         <td>
                                                        //             {parseFloat(entry.loan_principle || 0) + parseFloat(entry.loan_interest || 0)}
                                                        //         </td>


                                                        //         <td>
                                                        //             {entry.payment_type === "advanced" ? (
                                                        //                 <>
                                                        //                     <span className="text-success font-weight-bold me-2">Paid</span>
                                                        //                     <button
                                                        //                         className="btn btn-sm btn-danger"
                                                        //                         onClick={() => handleDelete(entry)}
                                                        //                     >
                                                        //                         Delete
                                                        //                     </button>
                                                        //                 </>
                                                        //             ) : (
                                                        //                 isPending ? (
                                                        //                     <>
                                                        //                         <button
                                                        //                             className="btn btn-sm btn-success me-2"
                                                        //                             onClick={() => handleSave(entry, entryIndex, itemIndex)}
                                                        //                         >
                                                        //                             Save
                                                        //                         </button>
                                                        //                         <button
                                                        //                             className="btn btn-sm btn-danger"
                                                        //                             onClick={() => handleDelete(entry)}
                                                        //                         >
                                                        //                             Delete
                                                        //                         </button>
                                                        //                     </>
                                                        //                 ) : (
                                                        //                     <span className="text-success font-weight-bold">Paid</span>
                                                        //                 )
                                                        //             )}

                                                        //         </td>

                                                        //     </tr>
                                                        // );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
